const downloadAppRedirect = {
    title: 'Proqramı yükləmək üçün keçid...',
    backBtn: 'Kataloqa qayıt',
};

export default downloadAppRedirect;
